import Vue from 'vue'
import router from './router'
import App from './App.vue'
import Vconsole from 'vconsole'
import VueWechatTitle from 'vue-wechat-title'
import VueDialog from './components/Dialog/index'
import Utils from "./utils/Utils";
import Urls from "./utils/Urls";
import Request from "./utils/Request";
Vue.use(VueDialog);
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
if (process.env.NODE_ENV != 'production') {
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}
if (process.env.NODE_ENV != 'development' && Urls.pchost && !Utils.isMobile())
{
  router.beforeEach((to, from, next) => {
    console.log('to',to)
    let url=Urls.pchost+'campus_index.html';
    // 面试预约页面重定向到PC端，携带sign参数
    if (to.path === '/interview') {
      url = Urls.pchost + 'interview_booking.html';
      if (to.query.sign) {
        url += '?sign=' + to.query.sign;
      }
      window.location.replace(url);
      return;
    }
    switch (to.path)
    {
      case '/positionlist':
        url=Urls.pchost+'campus-recruit-list.html';
        window.location.replace(url);
        break;
      case '/position':
      case '/delivery':
        url=Urls.pchost+'campus-recruit-list.html?pid='+to.query.id;
        window.location.replace(url);
        break;
      case '/deliverylist':
      case '/resume':
      case '/process':
        url=Urls.pchost+'personal-center.html';
        window.location.replace(url);
        break;
      case '/intro':
        url=Urls.pchost+'campus_introduce.html';
        window.location.replace(url);
        break;
      case '/qa':
        url=Urls.pchost+'campus_news.html';
        window.location.replace(url);
        break;
      default:
        window.location.replace(url);
        break;
    }
    next()
  })
}
try {
  let isProd = (process.env.NODE_ENV == 'production' ? true : false);
  window.TDTP && window.TDTP.init(isProd, "效能", "招聘官网", '');
} catch(e) {
  console.error(e)
}
try {
  Request.request(Urls.addAccessLog, {
    app: "Campus_" + Utils.getApp(),
    url: window.location.href,
    router: window.location.hash,
    referer: window.document.referrer,
    type: 1
  });
}
catch (e){
}
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
